import { useEffect, useState } from 'react'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import SponsorEventTable from './SponsorEventTable'
import SponsorSubEventTable from './SponsorSubEventTable'
import { EVENT_TABS } from '@/constants/event'
import { useSearchParams } from 'react-router-dom'

function SponsorshipData() {
  const [searchParams, setSearchParams] = useSearchParams()
  const tabParam = searchParams.get('tab')
  const [activeTab, setActiveTab] = useState(
    tabParam === EVENT_TABS.SUB_EVENT
      ? EVENT_TABS.SUB_EVENT
      : EVENT_TABS.MAIN_EVENT
  )

  useEffect(() => {
    if (
      tabParam === EVENT_TABS.SUB_EVENT ||
      tabParam === EVENT_TABS.MAIN_EVENT
    ) {
      setActiveTab(tabParam)
    }
  }, [searchParams])

  const handleTabChange = (value: string) => {
    setActiveTab(value)
    setSearchParams({ tab: value })
  }

  return (
    <div className="flex flex-col gap-6">
      <Tabs
        value={activeTab}
        onValueChange={handleTabChange}
        className="w-full"
      >
        <TabsList className="flex items-center h-auto p-1 bg-transparent w-fit flex-wrap mx-6">
          <TabsTrigger
            value="main-events"
            className="bg-transparent text-ss-neutral-950 px-4 py-1.5 lg:px-6 lg:py-3 rounded-[36px] text-sm font-semibold transition-colors hover:bg-ss-neutral-25 data-[state=active]:bg-ss-blue-900 data-[state=active]:text-white h-auto"
          >
            Admin Assigned Events
          </TabsTrigger>
          <TabsTrigger
            value="sub-events"
            className="bg-transparent text-ss-neutral-950 px-4 py-1.5 lg:px-6 lg:py-3 rounded-[36px] text-sm font-semibold hover:bg-ss-neutral-25 data-[state=active]:bg-ss-blue-900 data-[state=active]:text-white h-auto transition-colors"
          >
            Admin Assigned Sub Events
          </TabsTrigger>
        </TabsList>

        <TabsContent value="main-events">
          <SponsorEventTable />
        </TabsContent>

        <TabsContent value="sub-events">
          <SponsorSubEventTable />
        </TabsContent>
      </Tabs>
    </div>
  )
}

export default SponsorshipData
